module.exports = __webpack_public_path__ + "img/btn-notice2.1df3e044.png";